<!--
  name : 김혜진
  desc : 계약작성
  date : 2020-10-20
-->
<template>
  <v-stepper v-model="e1" class="write_stepCon con_mpw">

    <!--step_header-->
    <div class="write_step_top">
      <v-stepper-header>
        <v-stepper-step id="Wstep01" :class="headerCSS(1)"
          editable
        >
          수신자 입력
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step id="Wstep02" :class="headerCSS(2)"
          editable
        >
          계약서 작성
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step id="Wstep03" :class="headerCSS(3)"
          editable
        >
          계약서 전송
        </v-stepper-step>
      </v-stepper-header>
    </div>

    <!--step_con-->
    <v-stepper-items>

      <!--stepper-1-->
      <v-stepper-content step="1" :class="getDisplay(1)" id="write_S01">
          <select-target v-if="this.step === 1" v-on:initStep="initStep" v-on:nextStep="nextStep" ref="selectTarget" :key="SelectTargetKey" :parent-data="ParamJson"></select-target>
      </v-stepper-content>

      <!--stepper-2-->
      <v-stepper-content step="2" :class="getDisplay(2)" id="write_S02">
          <upload-contract v-if="this.step === 2" v-on:initStep="initStep" v-on:prevStep="prevStep" v-on:nextStep="nextStep" :parent-data="ParamJson"  ref="uploadContract" :key="CtrDocKey"></upload-contract>
      </v-stepper-content>

      <!--stepper-3-->
      <v-stepper-content step="3" :class="getDisplay(3)" id="write_S03">
          <request-ctr v-if="this.step === 3"  v-on:prevStep="prevStep" v-on:initStep="initStep" v-on:nextStep="nextStep" :parent-data="ParamJson" ref="ctrReq" :key="CtrReqKey"></request-ctr>
      </v-stepper-content>
      
    </v-stepper-items>
    
  </v-stepper>
</template>
<script>
import uploadContract from '@/views/contract/addNew/components/uploadContract.vue'
import selectTarget from '@/views/contract/addNew/components/selectTarget'
import requestCtr from '@/views/contract/addNew/components/requestCtr'

export default {
  name: 'write',
  components: {
		selectTarget,
		uploadContract,
		requestCtr
  },
  filters: {
  },
  props:{
  },
  data () {
    return {
      // 스텝퍼
      e1: 1,
      // 다이얼로그
      poPprove00: false,
      poPreceiv: false,
      poPgroup: false,
      plusGroup: false,
      next2step: false,
      paying: false,
			payEnd: false,
			

			step: 0,
      SelectTargetKey: 0,
      CtrDocKey: 0,
      CtrReqKey: 0,
      CtrWaterMarkKey: 0,
      ParamJson: {},
      titleVisible: true
    }
  },
  created () {
  },
  mounted () {
    this.track()
		this.$store.dispatch('removeTargetJson', '')
    this.step = 1
  },
  methods: {
    track () {
      this.$gtag.pageview({
        page_path: '/contrackWrite'
      })
    },
		nextStep (currentStep, data) {
      switch (currentStep) {
        case 1:
          if (this.CtrDocKey !== 0) {
            this.CtrDocKey = this.CtrDocKey + 1
          }
          this.ParamJson = data
          this.step = 2
          break
        case 2:
          this.CtrReqKey = this.CtrReqKey + 1
          this.ParamJson = data
					this.step = 3
          break
        default:
      }
    },
    prevStep (prevStep, data) {
			// parent Emit prev Step
      this.initStep(prevStep, data)
    },
    initStep (initStep, data) {
      switch (initStep) {
        case 1:
          this.SelectTargetKey = this.SelectTargetKey + 1
          this.CtrDocKey = this.CtrDocKey + 1
					this.CtrReqKey = this.CtrReqKey + 1
					this.ParamJson = data
					this.step = 1
          break
        case 2:
          this.step = 1
					this.CtrDocKey = this.CtrDocKey + 1
					this.ParamJson = data
          break
        case 3:
          this.step = 2
          this.CtrDocKey = this.CtrDocKey + 1
					this.CtrReqKey = this.CtrReqKey + 1
					this.ParamJson = data
          break
        case 4:
          this.step = 3
					this.CtrReqKey = this.CtrReqKey + 1
					this.ParamJson = data
          break
        default:
      }
		},
		stepGo(index) {
			this.step = index
		},
		getDisplay(index) {
			let CssName = ''
			if(this.step === index) {
				CssName = "display"
			}
			return CssName
		},
		headerCSS(index) {
			let CssName = ''

			if(this.step === index) {
				CssName = "on"
			}else{
				CssName = ""
			}

			return CssName
		}
  }
}
</script>
<style scoped>
.display { display: block !important;}
</style>